import React, { Component } from "react";
import { checkTranslation, imageAddress, translate } from "../utils/useful";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Modal from "./Modal";
import * as actions from "../stores/actionsList";
import { Router } from "react-router-dom";


class TabFolder extends Component {

    state = {
        open: false,
        minimizedwindows: [],
        minimizedTab: false,
        // user: [
        //     { label: 'Hossein Mohseni', function: 'openWindow', value: 'Settings', image: '/assets/icons/hossein.svg' },
        // ],

        actions: [
            { label: '{{lang}}Create Hub', function: 'openWindow', value: 'CreateHub' },
            { label: '{{lang}}Create Applet', function: 'openWindow', value: 'CreateApplet' },
            { label: '{{lang}}Portals', function: 'openWindow', value: 'Prtals' },
            { label: '{{lang}}Hubs', function: 'openWindow', value: 'Hubs' },
            { label: '{{lang}}Dashboard', function: 'openWindow', value: 'Dashboard' },
            { label: '{{lang}}Update', function: 'openWindow', value: 'Update' },
        ]
    }

    toggle = (open) => {
        this.setState({ open: open == null ? !this.state.open : open })
    }

    LogoutModal = () => {
        this.logoutModal.showModal()
    }
    openMinimizedTab = () => {
        this.setState({ minimizedTab: !this.state.minimizedTab })
        this.toggle();
    }
    openWindow = (id) => {
        // console.log('idddddddd', id);
        let windows = JSON.parse(JSON.stringify(this.props.windows))
        windows[id].minimized = false
        //    setTimeout(() => {

        this.props.actions.changeWindow(windows)
        // }, 200);
        this.props.changeIndex(id, windows)

    }
    componentDidMount = () => {
        // let minimized = Object.values(this.props.windows).filter((value) => value?.minimized == true)
        // console.log('minimized', minimized.length)
    }
    logout = () => {
        // console.log("logout")
        this.props.actions.logoutUser()
        // Router.push('/')
        this.props.addNewWindow("authentication", {}, "center")
        // this.props.history.push(pathMaker('/'))

        this.logoutModal.hideModal()
    }

    render() {

        return (
            <>
                <div className={"tab-folder " + (this.state.open ? ' open' : '')} style={{}}>
                    <div className="h-100 ">
                        {Object.values(this.props.windows).filter((value) => value?.minimized == true)?.length > 0 && (
                            <div className="tab-folder-header" >
                                <div>
                                    <div className="flexcc" style={{ cursor: 'pointer' }}>
                                        <div className="tab-folder-touch-indicator" onClick={() => this.openMinimizedTab()}>
                                        </div>
                                    </div>
                                </div>
                                {!this.state.open && (
                                    <div className="" style={{ cursor: 'pointer' }} >
                                        <div className="px-2 py-1 flexc pb-3" style={{ borderRadius: 0 }}>
                                            <div className="flexcc tab-folder-button" onClick={() => this.openMinimizedTab()}>
                                                <img className="br-50 p-2" style={{ width: '60px' }} src='/assets/icons/mini.svg' />
                                                <p className="text-white text-small flexcc position-absolute bg-blue br-20" style={{ top: '-5px', right: '-5px', width: '30px', height: '30px', textAlign: 'center', border: '3px solid #eee' }}>{Object.values(this.props.windows).filter((value) => value?.minimized == true)?.length}</p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {this.state.minimizedTab && (
                            <div className="h-100 tab-folder-body scroll-no-scrollbar">
                                {Object.values(this.props.windows).filter((value) => value?.minimized == true).map((window, index) => {
                                    return (
                                        <div className="" style={{ cursor: 'pointer' }} >
                                            <div className="py-3 flexcb w-100 bb-gray" style={{ borderBottom: index == Object.values(this.props.windows).filter((value) => value?.minimized == true).length - 1 ? '' : '1px solid #f2f6f8', borderRadius: 0 }} onClick={() => this.openWindow(window.id)}>
                                                <p>{checkTranslation(window.type)}</p>
                                                <img src="/assets/icons/arrow-right-gray.svg" height={16} />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif });
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TabFolder);
